import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import {
  COOKIE_CONSENT_EVENT,
  getSavedCookieConsent,
} from "./CookieBanner";
import {
  initializeFacebookPixel,
  loadFacebookPixelScript,
  trackFacebookPixelPageView,
} from "../../lib/facebookPixel";

export function FacebookPixel() {
  const location = useLocation();
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    setHasConsent(getSavedCookieConsent() === "accepted");

    const handleConsentChange = () => {
      setHasConsent(getSavedCookieConsent() === "accepted");
    };

    window.addEventListener(COOKIE_CONSENT_EVENT, handleConsentChange);
    return () => {
      window.removeEventListener(COOKIE_CONSENT_EVENT, handleConsentChange);
    };
  }, []);

  useEffect(() => {
    if (!hasConsent) return;

    initializeFacebookPixel();
    loadFacebookPixelScript();
    trackFacebookPixelPageView();
  }, [hasConsent, location.pathname, location.search]);

  return null;
}
